export const fieldsList = (coApplicantNumbers: number) => {
    const fields = [
        {
            "label": "Aadhaar Verified",
            "name": `basicCoApplicant${coApplicantNumbers}AadhaarVerified`,
            "type": "boolean",
            "required": true
        },
        {
            "label": "Do you want to consider income of the co-applicant for loan evaluation?",
            "name": `basicCoApplicant${coApplicantNumbers}PayParty`,
            "type": "radio",
            "required": true,
            "options": {
                "options": [
                    "Yes",
                    "No"
                ]
            }
        },
        {
            "label": "Owner Ship Status",
            "name": `addressCoApplicant${coApplicantNumbers}permanentOwnershipStatus`,
            "type": "dropdown",
            "required": true,
            "options": {
                "options": [
                    "Rented",
                    "Owned"
                ]
            }
        },
        {
            "label": "Year in current Address",
            "name": `addressCoApplicant${coApplicantNumbers}permanentYearsInCurrentAddress`,
            "type": "number",
            "required": true
        },
        {
            "label": "Year in current City",
            "name": `addressCoApplicant${coApplicantNumbers}permanentYearsInCurrentCity`,
            "type": "number",
            "required": true
        },
        {
            "label": "Address Line 1",
            "name": `addressCoApplicant${coApplicantNumbers}permanentAddressLine1`,
            "type": "text",
            "required": true
        },
        {
            "label": "Address Line 2",
            "name": `addressCoApplicant${coApplicantNumbers}permanentAddressLine2`,
            "type": "text",
            "required": false
        },
        {
            "label": "Address Line 3",
            "name": `addressCoApplicant${coApplicantNumbers}permanentAddressLine3`,
            "type": "text",
            "required": false
        },
        {
            "label": "Pincode",
            "name": `addressCoApplicant${coApplicantNumbers}permanentPincode`,
            "type": "text",
            "required": true
        },
        {
            "label": "City",
            "name": `addressCoApplicant${coApplicantNumbers}permanentCity`,
            "type": "autocomplete",
            "required": true
        },
        {
            "label": "State",
            "name": `addressCoApplicant${coApplicantNumbers}permanentState`,
            "type": "autocomplete",
            "required": true
        },
        {
            "label": "Country",
            "name": `addressCoApplicant${coApplicantNumbers}permanentCountry`,
            "type": "autocomplete",
            "required": true
        },
        {
            "label": "Keep Current Address same as Permanent Address",
            "name": `addressCoApplicant${coApplicantNumbers}currentsameAsPermanent`,
            "type": "checkbox",
            "required": false
        },
        {
            "label": "Owner Ship Status",
            "name": `addressCoApplicant${coApplicantNumbers}currentOwnershipStatus`,
            "type": "dropdown",
            "required": true,
            "options": {
                "options": [
                    "Rented",
                    "Owned"
                ]
            }
        },
        {
            "label": "Year in current Address",
            "name": `addressCoApplicant${coApplicantNumbers}currentYearsInCurrentAddress`,
            "type": "text",
            "required": true
        },
        {
            "label": "Year in current City",
            "name": `addressCoApplicant${coApplicantNumbers}currentYearsInCurrentCity`,
            "type": "text",
            "required": true
        },
        {
            "label": "Address Line 1",
            "name": `addressCoApplicant${coApplicantNumbers}currentAddressLine1`,
            "type": "text",
            "required": true
        },
        {
            "label": "Address Line 2",
            "name": `addressCoApplicant${coApplicantNumbers}currentAddressLine2`,
            "type": "text",
            "required": false
        },
        {
            "label": "Address Line 3",
            "name": `addressCoApplicant${coApplicantNumbers}currentAddressLine3`,
            "type": "text",
            "required": false
        },
        {
            "label": "Pincode",
            "name": `addressCoApplicant${coApplicantNumbers}currentPincode`,
            "type": "text",
            "required": true
        },
        {
            "label": "City",
            "name": `addressCoApplicant${coApplicantNumbers}currentCity`,
            "type": "autocomplete",
            "required": true
        },
        {
            "label": "State",
            "name": `addressCoApplicant${coApplicantNumbers}currentState`,
            "type": "autocomplete",
            "required": true
        },
        {
            "label": "Country",
            "name": `addressCoApplicant${coApplicantNumbers}currentCountry`,
            "type": "autocomplete",
            "required": true
        },
        {
            "label": "Are you employed?",
            "name": `employmentCoApplicant${coApplicantNumbers}isEmployed`,
            "type": "radio",
            "required": true,
            "options": {
                "options": [
                    "Yes",
                    "No"
                ]
            }
        },
        {
            "label": "Employment Type",
            "name": `employmentCoApplicant${coApplicantNumbers}employmentType`,
            "type": "dropdown",
            "required": true,
            "options": {
                "options": [
                    "FARMER",
                    "Salaried",
                    "SEP",
                    "SENP",
                    "Others"
                ]
            }
        }
    ]

    return fields;
}